<template>
  <div>
    <b-modal v-model="modal_warning" title="Warning" ok-only>
      <p>
        {{ $t('trans.orderOutdated') }}
      </p>
    </b-modal>
  
    <items :data="current.data" />
    <delivery :data="current.data" />
    <updates :data="current.data" />
  
    <b-row>
      <b-col cols="8">
        <b-row>
          <b-col v-if="$store.state.auth.user.role !== 'distributor'">
            <b-form-select v-model="$parent.$parent.selected_ship" :options="$parent.$parent.ships"
              :title="getSelectedShipTooltip" v-b-tooltip.hover size="sm" />
          </b-col>
          <b-col class="text-left">
            <b-button variant="info" size="sm" @click="updateTransactions()">
              {{ $t('trans.checkUpdates') }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  
    <b-overlay :show="show_spinner" opacity="0.9" bg-color="white" class="mt-4">
      <template #overlay>
        <div class="text-center">
          <b-icon icon="hourglass" font-scale="2" animation="spin" />
          <p>{{ $t('trans.loading') }}</p>
        </div>
      </template>
  
      <b-table v-if="!show_spinner" class="secondary" :stacked="is_mobile" :items="visibleRows()" :fields="visible_fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :busy="is_busy" select-mode="single" selectable show-empty
        responsive sort-icon-left small hover>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle" />
            <strong>&nbsp;{{ $store.state.fickle.requests.current_request }}</strong>
          </div>
        </template>
  
        <template #cell(createdAt)="data">
          {{ utils.formatDate(data.value).datetime }}
        </template>
  
        <template #cell(userId)="row">
          <div v-if="row.item.statusChangeLog && row.item.statusChangeLog.length > 0">
            {{ row.item.statusChangeLog[0].userEmail }}
          </div>
        </template>
  
        <template #cell(provider)="row">
          <b-link @click="showItems(row.item)" class="smt17">
            {{ row.item.productType }}
          </b-link>
        </template>
  
        <template #cell(lastDeliveryDate)="row">
          <span v-if="row.item.status === 'complete'">
            <b-link @click="showDelivery(row.item)" class="smt17">{{
              utils.formatDate(row.item.updatedAt).date
              }}</b-link>
          </span>
        </template>
  
        <template #cell(device-shipName)="row">
          <span v-b-tooltip.hover :title="row.item.device ? row.item.device.deviceId : ''">{{
            shipName(row.item.device).type
            }} <br> {{ shipName(row.item.device).val }}</span>
        </template>
  
        <template #cell(paymentMethod-paymentMethod)="row">
          <span v-if="row.item.paymentMethod?.paymentMethod === 'agreement'">{{ $t('trans.agreement') }}<br>{{
            row.item.paymentMethod.agreementInfo.title }}</span>
          <span v-else>{{ row.item.paymentMethod?.paymentMethod }}</span>
        </template>
  
        <template #cell(load)="row">
          <b-button-group>
            <!-- TODO -->
            <b-button :disabled="true"
              v-if="$store.state.auth.user.role === 'distributor' && row.item.status !== 'complete' && row.item.status !== 'download_charts' && row.item.device && row.item.device.appTypeId && (row.item.device.appTypeId === 101 || row.item.device.appTypeId === 102 || row.item.device.appTypeId === 105 || row.item.device.appTypeId === 11 || row.item.device.appTypeId === 10) && row.item.paymentMethod.paymentMethod === 'agreement'"
              size="sm" variant="info" @click="loadOrder(row.item)" class="mr-1">
              {{ $t('trans.edit') }}
            </b-button>
            <b-dropdown size="sm"
              v-if="$store.state.auth.user.role === 'distributor' && row.item.status !== 'complete' && row.item.status !== 'download_charts' && row.item.device && row.item.device.appTypeId && (row.item.device.appTypeId === 101 || row.item.device.appTypeId === 102 || row.item.device.appTypeId === 105 || row.item.device.appTypeId === 11 || row.item.device.appTypeId === 10) && row.item.paymentMethod.paymentMethod === 'agreement'"
              variant="info" text="Status">
              <b-dropdown-item @click="approveOrder(row.item, 'pre_order')">
                {{ $t('trans.request') }}
              </b-dropdown-item>
              <b-dropdown-item @click="approveOrder(row.item, 'owner_approved')">
                {{ $t('trans.topay') }}
              </b-dropdown-item>
              <b-dropdown-item @click="approveOrder(row.item, 'cancelled_by_distirbutor')">
                {{ $t('trans.cancel')
                }}
              </b-dropdown-item>
            </b-dropdown>
          </b-button-group>
        </template>
  
        <template #cell(status)="row">
          <h6>
            <b-badge :variant="getStatus(row.item.status).style">
              {{ getStatus(row.item.status).name }}
            </b-badge>
          </h6>
        </template>
  
        <template #cell(displayId)="row">
          <span v-b-tooltip.hover :title="row.item.orderId">{{ row.item.displayId }}</span>
        </template>
  
        <template #cell(updatedAt)="row">
          <b-link @click="showUpdates(row.item)" class="smt17">
            {{ utils.formatDate(row.item.updatedAt).date }}
          </b-link>
        </template>
  
        <template #cell(price-price)="row">
          <div v-if="row.item.price && row.item.price.currency && row.item.price.currency === 'RUB'">
            {{ row.item.price.price }} ₽
          </div>
          <div v-if="row.item.price && row.item.price.currency && row.item.price.currency === 'EUR'">
            {{ row.item.price.price }} €
          </div>
          <div v-if="row.item.price && row.item.price.currency && row.item.price.currency === 'USD'">
            ${{ row.item.price.price }}
          </div>
          <div
            v-if="row.item.price && row.item.price.currency && row.item.price.currency === '' && row.item.paymentMethod.paymentMethod === 'stripe'">
            {{ row.item.price.price }} €
          </div>
          <div
            v-if="row.item.price && row.item.price.currency && row.item.price.currency === '' && row.item.paymentMethod.paymentMethod === 'yoomoney'">
            {{ row.item.price.price }} ₽
          </div>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>

<script>
import { getAppName } from "@/utils/utils";
import Items from "@/views/transactions/sidebars/Items.vue";
import Delivery from "@/views/transactions/sidebars/Delivery.vue";
import Updates from "@/views/transactions/sidebars/Updates.vue"
import router from "@/router";
import * as utils from "../../utils/utils";
// import { changeOrderStatus } from "@/helpers/offline";
import { mapStores } from "pinia";
import { loadFleetTransactions } from "../../helpers/apiFleet";
import { useDeviceStore } from "@/stores/device";
import { useFleetStore } from "@/stores/fleet";
import { loadOrder, updateOrderStatus } from "@/helpers/api";

export default {
  name: "Transactions",
  components: { Updates, Delivery, Items },
  data() {
    return {
      windowWidth: window.innerWidth,
      modal_warning: false,
      show_spinner: false,
      qrcode: null,
      source1: 'report.pdf',
      sortBy: 'updatedAt',
      sortDesc: true,
      sortDirection: 'desc',
      isBusy: false,
      current: {
        status_id: '',
        data: null
      },
      ship: {},
      updateTimeout: null,
      isLoadingTransactions: false // Флаг состояния загрузки
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    // Запускаем первое обновление и планируем следующие
    this.updateTransactions();
  },
  beforeDestroy() {
    // Останавливаем автоматическое обновление при уходе со страницы
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
  },
  computed: {
    ...mapStores(useDeviceStore, useFleetStore),
    is_mobile() {
      return this.windowWidth <= 760
    },
    is_busy() {
      return this.fleetStore.transactions.length > 0 && this.fleetStore.transactions[0] === "-1"
    },
    utils() {
      return utils
    },
    visible_fields() {
      return [
        {
          key: 'displayId',
          label: this.$t('transactions.id'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'createdAt',
          label: this.$t('transactions.date'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'userId',
          label: this.$t('transactions.customer'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'device-shipName',
          label: this.$t('transactions.ship'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'provider',
          label: this.$t('transactions.content'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'paymentMethod-paymentMethod',
          label: this.$t('transactions.payment'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'price-price',
          label: this.$t('transactions.price'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'status',
          label: this.$t('transactions.status'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        {
          key: 'updatedAt',
          label: this.$t('transactions.updated'),
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'small-black',
          thClass: 'small-gray'
        },
        // {
        //   key: 'lastDeliveryDate',
        //   label: 'Deliveries',
        //   sortable: false,
        //   sortDirection: 'desc',
        //   tdClass: 'small-black',
        //   thClass: 'small-gray'
        // },
        { key: 'load', label: '', sortable: false, sortDirection: 'desc', tdClass: 'small-black', thClass: 'small-gray' },
      ]
    }
  },
  methods: {
    async updateTransactions() {
      // Проверяем, не выполняется ли уже загрузка
      if (this.isLoadingTransactions) {
        console.log('Пропускаем обновление - уже выполняется загрузка');
        return;
      }

      try {
        this.isLoadingTransactions = true;
        await loadFleetTransactions(true, true);
      } catch (error) {
        console.error('Ошибка при обновлении транзакций:', error);
      } finally {
        this.isLoadingTransactions = false;
        // Планируем следующее обновление через 10 секунд
        this.scheduleNextUpdate();
      }
    },

    scheduleNextUpdate() {
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout);
      }

      this.updateTimeout = setTimeout(() => {
        this.updateTransactions();
      }, 10000); // 10 секунд
    },

    getSelectedShipTooltip() {
      let tooltip = ''
      if (this.$store.state.auth.user.role === 'distributor') {
        let deviceId = this.$parent.$parent.selected_ship;
        let ship = this.$parent.$parent.ships.find(e => e.value === deviceId);
        tooltip = ship?.email + ", " + deviceId;
      }
      return tooltip
    },
    getStatus(status) {
      let val = {}
      switch (status) {
        case 'pre_order':
          val = { style: "info", name: this.$t('transactions.request') }
          break
        case 'owner_approved':
          val = { style: "warning", name: this.$t('transactions.toPay') }
          break
        case 'new':
          val = { style: "warning", name: this.$t('transactions.toPay') }
          break
        case 'paid':
        case 'ready_to_publish':
        case 'awaiting_charts"':
        case 'adding_charts"':
          val = { style: "secondary", name: this.$t('transactions.processing') }
          break
        case 'download_charts':
          val = { style: "light", name: this.$t('transactions.downloading') }
          break
        case 'complete':
          val = { style: "success", name: this.$t('transactions.complete') }
          break
        case 'error':
          val = { style: "danger", name: this.$t('transactions.error') }
          break
        case 'not_found':
          val = { style: "danger", name: this.$t('transactions.notFound') }
          break
        case 'cancelled_by_distirbutor':
          val = { style: "danger", name: this.$t('transactions.cancel') }
          break
        default:
          val = { style: "light", name: status }
      }

      return val
    },

    // ships() {
    //   let listWithAppstate = this.$store.state.proto.installationsECDIS;
    //   return listWithAppstate;
    // },

    async approveOrder(orderItem, status) {
      this.show_spinner = true
      try {
        const resp = await updateOrderStatus(orderItem.orderId, status);
        if (resp) {
          await this.updateTransactions(); // Используем наш метод с проверкой
        }
      } catch (error) {
        console.error('Ошибка при изменении статуса заказа:', error);
      } finally {
        this.show_spinner = false;
      }
    },

    shipName(device) {
      let val = 'unknown'
      let type = 'unknown'
      if (device !== null) {
        type = getAppName(device ? device.appTypeId : -1)
        val = device?.shipName ?? ''
      }
      return { "type": type, "val": val }
    },

    showItems(data) {
      this.current.data = data;
      this.$store.dispatch('fickle/getOrder', data.orderId)
      this.$root.$emit('bv::toggle::collapse', 'items-sidebar');
    },

    showDelivery(data) {
      this.current.data = data;
      this.$root.$emit('bv::toggle::collapse', 'delivery-sidebar');
    },

    showUpdates(data) {
      this.current.data = data;
      this.$root.$emit('bv::toggle::collapse', 'updates-sidebar');
    },

    visibleRows() {
      let orders = []
      let deviceID = this.deviceStore.getDeviceID
      if (deviceID) {
        orders = this.fleetStore.transactions.filter(function (e) {
          return e["device"]["deviceId"] === deviceID;
        });
      }

      if (this.$store.state.auth.user.role === 'distributor' || orders.length === 0 && this.fleetStore.transactions.length > 0)
        orders = this.fleetStore.transactions

      return orders;
    },

    loadOrder(orderItem) {
      loadOrder(orderItem.orderId).then(resp => {
        let orderId = orderItem.orderId
        let orderDate = orderItem.createdAt
        let shipName = orderItem.device.shipName
        let deviceId = orderItem.device.deviceId
        let appId = orderItem.device.appTypeId
        let status = orderItem.status
        let items = []
        let type = undefined
        let period = undefined

        resp.data.items.forEach(item => {
          items.push(item.id)
          period = item.monthCount
          type = item.type

          router.push({
            name: 'routes', params: {
              orderevent: 'change-order',
              order: { deviceId: deviceId, shipName: shipName, items: items, orderId: orderId }
            }
          })
        })
      })
    },
  },
}
</script>

<style>
.position-absolute {
  position: fixed !important;
}
</style>


<style scoped>
.truncate_name {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>